mutation ChartOfAccountDelete($input: ChartOfAccountDeleteInput!) {
  chartOfAccountDelete(input: $input) {
    deletedEntities {
      id
      rowTimestamp
    }
  }
}
